import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi, RetCode } from "../data-source/network-request";

/**
 * 修改文件名称
 */
export function renameFile(params) {
  return new RenameFileRequest(params).send();
}
/**
 * 修改文件名称
 */
export var RenameFileRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(RenameFileRequest, _DriveRequest);
  var _super = _createSuper(RenameFileRequest);
  function RenameFileRequest() {
    _classCallCheck(this, RenameFileRequest);
    return _super.apply(this, arguments);
  }
  _createClass(RenameFileRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", requestV1Cgi(payload));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      var padId = params.padId,
        title = params.title;
      return {
        method: 'post',
        url: RENAME_FILE_URL,
        data: {
          domain_id: DEFAULT_DOMAIN_ID,
          pad_id: padId,
          title: title,
          version: DEFAULT_VERSION,
          auto_change: DEFAULT_CHANGE,
          xsrf: getXsrfToken()
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if ((response === null || response === void 0 ? void 0 : response.retcode) !== RetCode.Success) {
        throw new DriveApiError({
          name: "RenameFileResultError",
          message: 'Rename file failed.',
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
    }
  }]);
  return RenameFileRequest;
}(DriveRequest);
var RENAME_FILE_URL = '/cgi-bin/online_docs/doc_changetitle';
var DEFAULT_VERSION = 2;
var DEFAULT_CHANGE = 0;
var DEFAULT_DOMAIN_ID = '300000000';
//# sourceMappingURL=rename-file.js.map